export const get_money_transition = `query get_money_transition($id: String!){
    get_money_transition(id: $id){
        transaction_code
        status
        from_account
        to_account
        amount
        currency
        transfer_date
        fulfillment_date
    }
}`;
